import { useEffect, useState } from "react";


function Hero() {
  const [data, setData] = useState(null);
const [hero, setHero] = useState(null);
  useEffect(() => {
    fetch("https://swiftintelli.com/api/getFullHero.php")
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => console.error(err));
  }, []);

  if (!data) return <div>Loading...</div>;

  return (
    <section className="si-hero">
      {/* ================= LEFT CONTENT ================= */}
      <div className="si-hero-content">
        {/* BADGE */}
        <div className="si-badge">
          <span className="si-badge-dot" />
          {data.hero?.announcement}
        </div>
        {/* TITLE */}
        <h1 className="si-h1">
          {data.hero.title1 || "Learn Fast."}
          <br />
          <span className="c1">{data.hero.title2 || "Build Boldly."}</span>
          <br />
          <span className="c2">{data.hero.title3 || "Upskill Smart."}</span>
        </h1>

        {/* DESCRIPTION */}
        <p className="si-hero-sub">{data.hero.description || ""}</p>

        {/* BUTTONS */}
        <div className="si-hero-actions">
          <a href="#courses" className="si-btn-primary">
            Explore Courses
          </a>
          <a href="#about" className="si-btn-secondary">
            About Us
          </a>
        </div>

        {/* STATS */}
        <div className="si-hero-stats">
          <div>
            <div className="si-stat-num">
              {data.hero.students}
              <span>+</span>
            </div>
            <div className="si-stat-label">Students Trained</div>
          </div>

          <div>
            <div className="si-stat-num">
              {data.hero.courses}
              <span>+</span>
            </div>
            <div className="si-stat-label">Expert Courses</div>
          </div>

          <div>
            <div className="si-stat-num">
              {data.hero.placement}
              <span>%</span>
            </div>
            <div className="si-stat-label">Placement Rate</div>
          </div>
        </div>
      </div>

      {/* ================= RIGHT SIDE CARDS ================= */}
      <div className="si-hero-visual">
        {data.courses.map((c, i) => (
          <div key={i} className="si-float-card">
            <div className="si-card-top">
              <div className="si-card-icon">{c.icon}</div>
              <div className="si-card-title">{c.title}</div>
              <span className={`si-card-tag ${c.tagClass}`}>{c.tag}</span>
            </div>

            <div className="si-card-meta">{c.meta}</div>

            <div className="si-progress-bar">
              <div
                className="si-progress-fill"
                style={{
                  width: c.progress + "%",
                  background:
                    c.color || "linear-gradient(90deg,#2563eb,#10b981)",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Hero;
